<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter">5</h1>
<h1 class="chapter1">ALMOND</h1>
<p class="indent">How many people are aware of the close relationship between the Almond (genus <em>Amygdalus</em>) and the Peach (genus <em>Persica</em>)? It is probable, indeed, that the former was, so to speak, the progenitor of the latter—that, in short, the luscious pulp which surrounds the hard ‘stone’ or shell of the peach, and forms the edible ‘fleshy’ portion of this widely-esteemed and largely-consumed fruit, is an outcrop upon the ‘stone’ which, inside its dry hairy covering, encloses the almond of commerce. If this be so, it is a case of evolution, the hard, almost fleshless almond fruit covering developing into the much larger but exteriorly soft and juicy envelope of the peach.</p>
<p class="indent">How the change has occurred is one of the profound mysteries of Nature; but in part proof, at least, of the likelihood of the supposition, is the fact that trees have been discovered with fruit in a transition stage—almonds on the way to become peaches. A curious point is to be noted in this process of evolution. The stone inside the peach is commonly smaller than the stone which encloses the kernel of the almond; and the kernel of the peach stone is also commonly smaller than that of the almond. Again, whilst the almond kernel becomes sweet and therefore pleasantly edible, the peach kernel is usually bitter, all the sweetness apparently centering in the luscious flesh. Almond kernels are sometimes bitter, and bitter and sweet ones may sometimes be found growing on the same tree.</p>
<p class="indent">The striking peculiarity of the almond is the extraordinarily early appearance—in advance of the leaves—of its pretty purple blossoms, which are often to be seen in March and sometimes as early as February. Although frost has the curious effect of brightening almond blossoms and not, apparently, damaging them, it is probable that injury is worked upon the incipient germ of the fruits, because it very frequently happens that no fruit succeeds the blossom.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c05.vue?02ae63d0